<template>
    <div class="stage-customer-type">
        <p class="customer-type-intro">Please select the customer type that best describes you to proceed with your quotation.</p>
        <div class="customer-type-grid">
            <div
                class="customer-type-card"
                :class="{ active: $store.state.customerType === 'private' }"
                @click="selectType('private')"
                role="button"
                tabindex="0"
                @keydown.enter="selectType('private')"
                @keydown.space.prevent="selectType('private')"
            >
                <div class="card-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                        <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                </div>
                <div class="card-title">Private</div>
                <div class="card-description">Individual homeowner or private buyer</div>
                <div class="card-check" v-if="$store.state.customerType === 'private'">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                </div>
            </div>
            <div
                class="customer-type-card"
                :class="{ active: $store.state.customerType === 'contractor' }"
                @click="selectType('contractor')"
                role="button"
                tabindex="0"
                @keydown.enter="selectType('contractor')"
                @keydown.space.prevent="selectType('contractor')"
            >
                <div class="card-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                        <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
                        <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
                    </svg>
                </div>
                <div class="card-title">Contractor</div>
                <div class="card-description">Business, trade or registered contractor</div>
                <div class="card-check" v-if="$store.state.customerType === 'contractor'">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'stage-customer-type',
    methods: {
        selectType(type) {
            this.$store.commit('updateCustomerType', type);
        }
    }
};
</script>

<style lang="scss" scoped>
.stage-customer-type {
    .customer-type-intro {
        font-size: 16px;
        margin-bottom: 30px;
        color: #555;
    }

    .customer-type-grid {
        display: flex;
        flex-flow: row nowrap;
        gap: 24px;

        @media screen and (max-width: 640px) {
            flex-flow: column;
        }

        .customer-type-card {
            flex: 1;
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 36px 24px;
            border: 2px solid #e0e0e0;
            border-radius: 6px;
            background-color: #fafafa;
            cursor: pointer;
            text-align: center;
            transition: border-color 180ms ease-out, background-color 180ms ease-out, box-shadow 180ms ease-out;
            user-select: none;

            &:hover {
                border-color: $cl-primary;
                background-color: transparentize($cl-primary, 0.95);
                box-shadow: 0 2px 12px transparentize($cl-primary, 0.85);
            }

            &:focus-visible {
                outline: 2px solid $cl-primary;
                outline-offset: 2px;
            }

            &.active {
                border-color: $cl-primary;
                background-color: transparentize($cl-primary, 0.93);
                box-shadow: 0 2px 16px transparentize($cl-primary, 0.8);

                .card-icon {
                    color: $cl-primary;
                }
                .card-title {
                    color: $cl-primary;
                }
            }

            .card-icon {
                color: #888;
                margin-bottom: 16px;
                transition: color 180ms ease-out;
            }

            .card-title {
                font-size: 20px;
                font-weight: 700;
                letter-spacing: 0.5px;
                margin-bottom: 8px;
                transition: color 180ms ease-out;
            }

            .card-description {
                font-size: 14px;
                color: #777;
                line-height: 1.4;
            }

            .card-check {
                position: absolute;
                top: 12px;
                right: 12px;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 28px;
                height: 28px;
                border-radius: 50%;
                background-color: $cl-primary;
                color: white;
            }
        }
    }
}
</style>
